export default __webpack_public_path__ + "static/media/sadAppleRed.27ae0694.svg";